export class StorageItems {
    public static readonly IsLoading: string = 'isLoading';
}

export class ApiPathKeys {
    public static readonly epochFrom: string = 'eoochFrom';
}

export class QueryParams {
    public static readonly epochTo: string = 'epochTo';
}
